import { render, staticRenderFns } from "./ManageTower.vue?vue&type=template&id=3670c4f4&scoped=true"
import script from "./ManageTower.vue?vue&type=script&lang=js"
export * from "./ManageTower.vue?vue&type=script&lang=js"
import style0 from "./ManageTower.vue?vue&type=style&index=0&id=3670c4f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3670c4f4",
  null
  
)

export default component.exports